module.exports = __webpack_public_path__ + "static/img/jiuzhan.eaa5832.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/yszq/jiuzhan.jpg
// module id = w1/v
// module chunks = 0